import React from "react";
import {
  ACTION_RAIL_LABEL,
  PROCESS_FRAME,
  PROCESS_MAIN,
  PROCESS_RAIL,
} from "./actionUiChrome";

/**
 * Run Payroll / Process Attendance chrome.
 * - Default: left rail + main (legacy)
 * - wizard prop: horizontal top strip (no sidebar) — preferred process UI
 */
export default function ProcessWorkflowShell({
  railLabel = "Steps",
  sidebar = null,
  wizard = null,
  accent = "payroll",
  children,
}) {
  const accentBorder =
    accent === "attendance"
      ? "border-teal-600/30 dark:border-teal-400/30"
      : "border-indigo-600/30 dark:border-indigo-400/30";

  if (wizard) {
    return (
      <div className={`${PROCESS_FRAME} flex-col ${accentBorder}`}>
        <div
          className={`shrink-0 border-b px-3 py-2 ${
            accent === "attendance"
              ? "border-teal-600/25 bg-teal-50/40 dark:border-teal-400/20 dark:bg-teal-950/20"
              : "border-indigo-600/25 bg-indigo-50/40 dark:border-indigo-400/20 dark:bg-indigo-950/20"
          }`}
        >
          {wizard}
        </div>
        <section className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-3">
          <div
            className={`${PROCESS_MAIN} ${
              accent === "attendance"
                ? "border-teal-600/35"
                : "border-indigo-600/35"
            }`}
          >
            {children}
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className={PROCESS_FRAME}>
      <aside className={PROCESS_RAIL}>
        <div className="px-2 py-2">
          <p className={ACTION_RAIL_LABEL}>{railLabel}</p>
        </div>
        <nav className="min-h-0 flex-1 overflow-y-auto px-1.5 pb-2">{sidebar}</nav>
      </aside>
      <section className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden p-3">
        <div className={PROCESS_MAIN}>{children}</div>
      </section>
    </div>
  );
}
